import { Injectable } from '@angular/core';
import { NewsService } from './services/news.service';
import { NewsContent } from './services/news.model';
import { CollectionQuery } from './../collections/services/content.interface';
import { PaginatedList, ReqFailureResponse } from '../../../../../../projects/api/src/public-api';
import { BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

export interface NewsListState {
  loading: boolean;
  count?: number;
  collections: NewsContent[];
  error?: string;
  message?: string;

}

const initialState: NewsListState = {
  loading: false,
  collections: [],
};

@Injectable({ providedIn: 'root' })
export class NewsListStateService {
  state = new BehaviorSubject<NewsListState>(initialState);

  constructor(private newsSvc: NewsService,
    private spinner: NgxSpinnerService,) { }


  find(query: Partial<CollectionQuery>) {
    this.loading();
    this.newsSvc
      .getNewsContent(query)
      .pipe(first())
      .subscribe({
        next: this.updateCollections.bind(this),
        error: this.onError.bind(this),
      });
  }

  private updateCollections(data: PaginatedList<NewsContent>) {
    this.state.next({
      loading: false,
      collections: data.data,
      count: data.count,
      message:"Loading Successful"
    });
    this.spinner.hide();
  }

  private onError(error: ReqFailureResponse) {
    this.state.next({
      ...this.state.getValue(),
      error: error.message,
      loading: false,
      message:"An Error Occurred"
    });
    this.spinner.hide();
  }

  reset() {
    this.state.next(initialState);
  }

  private loading() {
    this.spinner.show();
    this.state.next({
      ...this.state.getValue(),
      loading: true,
      message:"Loading..."
    });
  }
}
